import { Container } from "./Container";
import { Table } from "./Table";
import { Modal, ModalBody, Modalfooter } from "../../../Modal";
import { Input } from "../../../Auth";
import { useCallback, useEffect, useState } from "react";
import {
    getAllAcmt,
    createAcmt,
    updateAcmt,
    updateCert,
    uploadSertifikat,
    deleteAcmt,
    importAcmt,
} from "../../../../Api/acmt";
import useAuth from "../../../../Hooks/useAuth";
import Swal from "sweetalert2";

export const Prestasi = () => {
    const { auth } = useAuth();
    const [formShow, setFormShow] = useState(false);
    const [IFormShow, setIFormShow] = useState(false);
    const [search, setSearch] = useState("");
    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [pId, setPId] = useState(0);
    const [pPeserta, setPPeserta] = useState("");
    const [pKelas, setPKelas] = useState("");
    const [pLomba, setPLomba] = useState("");
    const [pPnylgr, setPPnylgr] = useState("");
    const [pTgl, setPTgl] = useState("");
    const [pTingkat, setPTingkat] = useState("");
    const [pJuara, setPJuara] = useState("");
    const [pSertifikat, setPSertifikat] = useState(null);
    const [pCSertifikat, setPCSertifikat] = useState("");
    const [fileName, setFileName] = useState("");
    const [oldFileName, setOldFileName] = useState("");
    const [Ifilename, setIfilename] = useState("");
    const [formType, setFormType] = useState("create");

    const [selectedFile, setSelectedFile] = useState(null);

    const handleSertifikatUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 1024 * 1024) {
            Swal.fire("Ukuran file maksimal 1MB", "", "warning");
            e.target.value = "";
            return;
        }

        setFileName(file.name);
        setPSertifikat(file);
    };

    const handleIfileChange = (event) => {
        const file = event.target.files[0];
        setIfilename(file.name);
        console.log(file.name);
        setSelectedFile(file);
    };

    const getDate = (datestr) => {
        const date = new Date(datestr);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${year}-${month}-${day}`;
    };

    const getFileName = (url) => {
        return url.split("/certificates/")[1];
    };

    const getAllData = useCallback(async () => {
        let result = await getAllAcmt();
        let data = result.data.data;
        if (result?.status && result?.data) {
            setAllData(data);
        }
    }, []);

    const filteredData = allData.filter((item) => {
        if (auth.role === "admin") {
            return (
                item.participant_name
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                (item.competition_name &&
                    item.competition_name
                        .toLowerCase()
                        .includes(search.toLowerCase()))
            );
        }
        return (
            item.school_id === auth.id &&
            (item.participant_name
                .toLowerCase()
                .includes(search.toLowerCase()) ||
                (item.competition_name &&
                    item.competition_name
                        .toLowerCase()
                        .includes(search.toLowerCase())))
        );
    });

    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleEditAcmt = (data) => {
        setFormType("edit");
        setPId(data.id);
        setPPeserta(data.participant_name);
        setPKelas(data.class);
        setPLomba(data.competition_name);
        setPPnylgr(data.organizer);
        setPTgl(getDate(data.competition_date));
        setPTingkat(data.competition_level);
        setPJuara(data.achievement_rank);
        setPCSertifikat(data.certificate_file);
        setFileName(getFileName(data.certificate_file));
        setOldFileName(getFileName(data.certificate_file));
        setFormShow(true);
    };

    const handleDownloadCert = (cert) => {
        Swal.fire({
            title: "Download sertifikat?",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "download",
            cancelButtonText: "batal",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-green-500 text-white hover:bg-green-600",
                cancelButton: "bg-red-500 text-white hover:bg-red-600",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const fileURL = global.BASE_URL + cert;
                    const fileName = cert.split("/certificates/")[1];

                    const response = await fetch(fileURL);
                    const blob = await response.blob();
                    const blobURL = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = blobURL;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(blobURL);

                    Swal.fire(
                        "Di Unduh",
                        "Sertifikat berhasil diunduh",
                        "success"
                    );
                } catch (err) {
                    console.error(err);
                    Swal.fire(
                        "Gagal",
                        "Terjadi kesalahan saat download",
                        "error"
                    );
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "", "error");
            }
        });
    };

    useEffect(() => {
        getAllData();
    }, [getAllData]);

    const clearData = () => {
        setPPeserta("");
        setPKelas("");
        setPLomba("");
        setPPnylgr("");
        setPTgl("");
        setPTingkat("");
        setPJuara("");
        setFileName("");
        setPSertifikat(null);
    };

    const handleCreateAcmt = async () => {
        if (formType === "create") {
            try {
                const formData = new FormData();
                formData.append("file", pSertifikat);

                let uploadedSrtfkt = await uploadSertifikat(formData);
                if (uploadedSrtfkt && uploadedSrtfkt.success) {
                    let sertifikatUrl = uploadedSrtfkt.data.file_url;
                    let newData = {
                        school_id: auth.id,
                        participant_name: pPeserta,
                        participant_class: pKelas,
                        competition_name: pLomba,
                        organizer: pPnylgr,
                        competition_date: pTgl,
                        competition_level: pTingkat,
                        achievement_rank: pJuara,
                        certificate_file: sertifikatUrl,
                    };

                    let created = await createAcmt(newData);

                    if (created && created.success) {
                        Swal.fire({
                            title: "Berhasil!",
                            text: "Berhasil menambah prestasi",
                            icon: "success",
                        });
                        clearData();
                        getAllData();
                    } else {
                        clearData();
                        getAllData();

                        Swal.fire({
                            title: "Gagal!",
                            text: "Gagal menambah prestasi",
                            icon: "error",
                        });
                    }
                } else {
                    clearData();
                    getAllData();

                    Swal.fire({
                        title: "Gagal!",
                        text: "Gagal mengunggah sertifikat",
                        icon: "error",
                    });
                }
            } catch (error) {
                clearData();
                getAllData();

                console.error("Kesalahan saat mengunggah data:", error);
                Swal.fire({
                    title: "Gagal!",
                    text: "Gagal mengunggah data",
                    icon: "error",
                });
            }
        } else {
            try {
                let sertifikatUrl;
                if (pSertifikat) {
                    let formData = new FormData();
                    formData.append("file", pSertifikat);
                    formData.append("old_file", oldFileName);
                    let updatedSrtfkt = await updateCert(formData);
                    sertifikatUrl = updatedSrtfkt.data.new_file_url;
                    if (!updatedSrtfkt.success) {
                        Swal.fire({
                            title: "Gagal!",
                            text: "Gagal mengunggah sertifikat baru",
                            icon: "error",
                        });
                    }
                }

                let updatedData = {
                    id: pId,
                    school_id: auth.id,
                    participant_name: pPeserta,
                    participant_class: pKelas,
                    competition_name: pLomba,
                    organizer: pPnylgr,
                    competition_date: pTgl,
                    competition_level: pTingkat,
                    achievement_rank: pJuara,
                    certificate_file: sertifikatUrl || pCSertifikat,
                };

                let updated = await updateAcmt(updatedData);

                if (updated && updated.success) {
                    Swal.fire({
                        title: "Berhasil!",
                        text: "Berhasil memperbarui prestasi",
                        icon: "success",
                    });
                    clearData();
                    getAllData();
                    setFormShow(false);
                } else {
                    Swal.fire({
                        title: "Gagal!",
                        text: "Gagal memperbarui prestasi",
                        icon: "error",
                    });
                }
            } catch (error) {
                console.error("Kesalahan saat memperbarui data:", error);
                Swal.fire({
                    title: "Gagal!",
                    text: "Gagal memperbarui data",
                    icon: "error",
                });
            }
        }
    };

    const downloadTemplateAcmt = () => {
        const fileURL =
            global.BASE_URL + "/certificates/achievement_import_template.xlsx";

        fetch(fileURL, { method: "HEAD" })
            .then((response) => {
                if (response.ok) {
                    const a = document.createElement("a");
                    a.href = fileURL;
                    a.download = "achievement_import_template.xlsx";
                    a.click();
                    Swal.fire(
                        "Di Unduh",
                        "Template berhasil di-download",
                        "success"
                    );
                } else {
                    Swal.fire("Error", "Data tidak ada", "error");
                }
            })
            .catch(() => {
                Swal.fire(
                    "Error",
                    "Terjadi kesalahan saat mengakses file",
                    "error"
                );
            });
    };

    const handleDownloadAcmt = () => {
        Swal.fire({
            title: "Download Semua Data?",
            text: "Semua data akan di download dalam file berbentuk excel!",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "download",
            cancelButtonText: "batal",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-green-500 text-white hover:bg-green-600",
                cancelButton: "bg-red-500 text-white hover:bg-red-600",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const fileURL = global.BASE_URL + "/data/achievement/export";

                fetch(fileURL, { method: "HEAD" })
                    .then((response) => {
                        if (response.ok) {
                            const a = document.createElement("a");
                            a.href = fileURL;
                            a.download = "prestasi.xlsx";
                            a.click();
                            Swal.fire(
                                "Di Unduh",
                                "Data berhasil di download",
                                "success"
                            );
                        } else {
                            Swal.fire("Error", "Data tidak ada", "error");
                        }
                    })
                    .catch(() => {
                        Swal.fire(
                            "Error",
                            "Terjadi kesalahan saat mengakses file",
                            "error"
                        );
                    });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "", "error");
            }
        });
    };

    const handleImportAcmt = async () => {
        if (!selectedFile) {
            Swal.fire({
                title: "Info!",
                text: "Pilih file terlebih dahulu",
                icon: "info",
            });
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            let imported = await importAcmt(formData);
            console.log(imported);
            if (imported && imported.success) {
                Swal.fire({
                    title: "Berhasil!",
                    text: imported.message,
                    icon: "success",
                }).then((a) => {
                    if (a.isConfirmed) {
                        getAllData();
                        setIFormShow(false);
                        setSelectedFile(null);
                        setFileName("Pilih File.");
                    }
                });
            } else {
                Swal.fire({
                    title: "Gagal!",
                    text: imported.message,
                    icon: "info",
                });
            }
        } catch (error) {
            console.error("Kesalahan saat mengunggah file:", error);
            Swal.fire({
                title: "Gagal!",
                text: "Gagal mengunggah data",
                icon: "error",
            });
        }
    };

    const handleDeleteAcmt = (id, certificate_file) => {
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Anda tidak akan bisa mengembalikannya!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Tidak, batal!",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-red-500 text-white hover:bg-red-600",
                cancelButton: "bg-gray-300 text-black hover:bg-gray-400",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                let deleted = await deleteAcmt(id, certificate_file);

                if (deleted && deleted?.success) {
                    Swal.fire("Dihapus!", deleted.message, "success");
                    getAllData();
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "", "error");
            }
        });
    };

    return (
        <Container>
            <div className="w-full flex flex-wrap justify-between items-center mb-3 mt-1 gap-2">
                <div>
                    <h3 className="text-lg font-semibold text-slate-800">
                        Data Prestasi
                    </h3>
                    <p className="text-slate-500">
                        List Semua Data Yang Telah Diraih
                    </p>
                    <div className="mt-2 flex flex-row gap-1 flex-wrap">
                        <button
                            onClick={() => {
                                setFormType("create");
                                clearData();
                                setFormShow(true);
                            }}
                            className="py-1 px-3 bg-green-500 text-white rounded hover:bg-green-600">
                            Tambah Data
                        </button>
                        <button
                            onClick={() => setIFormShow(true)}
                            className="py-1 px-3 bg-purple-500 text-white rounded hover:bg-purple-600">
                            Import Data
                        </button>
                        <button
                            onClick={() => handleDownloadAcmt()}
                            className="py-1 px-3 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Download Data
                        </button>
                    </div>
                </div>
                <div className="lg:ml-3">
                    <div className="w-full max-w-sm min-w-[200px] relative">
                        <input
                            onChange={(e) => setSearch(e.target.value)}
                            className="bg-white w-full pr-11 h-10 pl-3 py-2 text-slate-700 text-sm border border-slate-200 rounded shadow-sm focus:outline-none focus:border-slate-400 hover:border-slate-400"
                            placeholder="Cari Prestasi..."
                        />
                    </div>
                </div>
            </div>
            {formShow && (
                <Modal
                    title={`Form ${
                        formType === "create" ? "Tambah" : "Edit"
                    } Prestasi`}
                    onClose={() => setFormShow(false)}>
                    <ModalBody>
                        <Input
                            label="Nama Peserta"
                            type="text"
                            value={pPeserta}
                            onChange={(e) => setPPeserta(e.target.value)}
                        />
                        <Input
                            label="Kelas"
                            type="text"
                            value={pKelas}
                            onChange={(e) => setPKelas(e.target.value)}
                        />
                        <Input
                            label="Nama Lomba"
                            type="text"
                            value={pLomba}
                            onChange={(e) => setPLomba(e.target.value)}
                        />
                        <Input
                            label="Penyelenggara"
                            type="text"
                            value={pPnylgr}
                            onChange={(e) => setPPnylgr(e.target.value)}
                        />
                        <Input
                            label="Tanggal Lomba"
                            type="date"
                            value={pTgl}
                            onChange={(e) => setPTgl(e.target.value)}
                        />
                        <Input
                            label="Tingkat"
                            type="select"
                            value={pTingkat}
                            onChange={(e) => setPTingkat(e.target.value)}
                            options={[
                                { value: "kecamatan", label: "Kecamatan" },
                                { value: "kabupaten", label: "Kabupaten" },
                                { value: "provinsi", label: "Provinsi" },
                                { value: "nasional", label: "Nasional" },
                                {
                                    value: "internasional",
                                    label: "Internasional",
                                },
                            ]}
                        />
                        <Input
                            label="Juara"
                            type="text"
                            value={pJuara}
                            onChange={(e) => setPJuara(e.target.value)}
                        />
                        <Input
                            label="Sertifikat *maks 1 MB"
                            type="file"
                            fileName={fileName}
                            value={pSertifikat}
                            onChange={handleSertifikatUpload}
                        />
                    </ModalBody>
                    <Modalfooter>
                        <button
                            onClick={handleCreateAcmt}
                            className="w-full bg-blue-400 px-3 py-2 text-white border border-blue-500 hover:bg-blue-500 rounded">
                            {formType === "create" ? "Tambah" : "Edit"}
                        </button>
                    </Modalfooter>
                </Modal>
            )}

            {IFormShow && (
                <Modal title="Import Data Prestasi" onClose={setIFormShow}>
                    <ModalBody>
                        <div className="w-full h-full flex flex-col space-y-2">
                            <label
                                className="block text-sm font-medium text-gray-900 dark:text-white"
                                for="file_input">
                                Unggah File
                            </label>
                            <div className="relative w-full h-[48px]">
                                <input
                                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                    aria-describedby="file_input_help"
                                    id="file_input"
                                    type="file"
                                    accept=".xlsx"
                                    onChange={handleIfileChange}
                                />
                                <div className="flex items-center justify-between h-full px-4 bg-gray-50 border border-gray-300 rounded-lg">
                                    <span className="text-sm text-gray-500">
                                        {Ifilename}
                                    </span>
                                    <button
                                        type="button"
                                        className="px-3 py-1 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                                        Pilih
                                    </button>
                                </div>
                            </div>
                            <p
                                className="text-sm text-gray-500"
                                id="file_input_help">
                                Unggah file dalam format XLSX (Excel).
                            </p>
                            <button
                                onClick={() => downloadTemplateAcmt()}
                                className="w-full bg-purple-400 px-2 py-1 text-white border border-purple-500 hover:bg-purple-500 rounded">
                                unduh templat
                            </button>
                        </div>
                    </ModalBody>
                    <Modalfooter>
                        <button
                            onClick={handleImportAcmt}
                            className="w-full bg-blue-400 px-3 py-2 text-white border border-blue-500 hover:bg-blue-500 rounded">
                            Upload
                        </button>
                    </Modalfooter>
                </Modal>
            )}
            <Table
                displayedData={displayedData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                filteredData={filteredData}
                handleNextPage={handleNextPage}
                handlePrevPage={handlePrevPage}
                totalPages={totalPages}
                onAcmtEdit={handleEditAcmt}
                onCertDownload={handleDownloadCert}
                onAcmtDelete={handleDeleteAcmt}
            />
        </Container>
    );
};
